import React, { useState } from 'react';
import { ButtonGroupOption } from 'global';
import { useSelector } from 'react-redux';
import { ButtonGroup, Button } from '@mui/material';
import { ProposalsMetricsDashboard } from 'modules/proposals';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PartnerProposalsTableContainer } from '../../tables';
import { ProposalsPageButtonGroupOptions } from 'modules/aftermarketPartner/types';
import { usePortalConfigurationChecks } from 'modules/portalConfigurations';

export const AftermarketPartnerProposalsPage = () => {
  const account = useSelector((state: any) => state.account);
  const { checkAftermarketPartnerAllowSendProposals } = usePortalConfigurationChecks();

  const [currentType, setProposalsType] = useState<ProposalsPageButtonGroupOptions>(
    ProposalsPageButtonGroupOptions.DealerProposals
  );

  const buttonGroups: Record<string, ButtonGroupOption<ProposalsPageButtonGroupOptions>> = {
    [ProposalsPageButtonGroupOptions.Dashboard]: {
      label: ProposalsPageButtonGroupOptions.Dashboard,
      value: ProposalsPageButtonGroupOptions.Dashboard,
      component: <ProposalsMetricsDashboard />,
      isVisible: true,
    },
    [ProposalsPageButtonGroupOptions.DealerProposals]: {
      label: ProposalsPageButtonGroupOptions.DealerProposals,
      value: ProposalsPageButtonGroupOptions.DealerProposals,
      component: (
        <PartnerProposalsTableContainer
          accountId={account.id}
          viewTab={ProposalsPageButtonGroupOptions.DealerProposals}
        />
      ),
      isVisible: true,
    },
    [ProposalsPageButtonGroupOptions.YourProposals]: {
      label: ProposalsPageButtonGroupOptions.YourProposals,
      value: ProposalsPageButtonGroupOptions.YourProposals,
      component: (
        <PartnerProposalsTableContainer
          accountId={account.id}
          viewTab={ProposalsPageButtonGroupOptions.YourProposals}
        />
      ),
      isVisible: checkAftermarketPartnerAllowSendProposals(),
    },
  };

  return (
    <PageContainer title="Proposals">
      <CardContainer>
        <ButtonGroup fullWidth>
          {Object.values(buttonGroups)
            .filter(({ isVisible = true }) => isVisible)
            .map(({ label, value }) => (
              <Button
                key={value}
                variant={currentType === value ? 'contained' : 'outlined'}
                onClick={() => {
                  if (currentType === value) return;
                  setProposalsType(value);
                }}
              >
                {label}
              </Button>
            ))}
        </ButtonGroup>
        {buttonGroups[currentType].component}
      </CardContainer>
    </PageContainer>
  );
};
